import service from "./service.js";

export const getTemFromManufacture = manufacture => {
  return service.get(`/v1/tem/manufacture`, { manufacture });
};

export const findTemDetail = listQuery => {
  return service.get("/v1/tem/detail", listQuery);
};

export const create = tem => {
  return service.post(`/v1/tem`, { tem });
};

export const createTemOrder = tem => {
  return service.post(`/v1/tem/dh`, { tem });
};

export const print = listTems => {
  return service.post(`/v1/tem/print`, { listTems });
};

export const destroy = (id, note) => {
  return service.post(`/v1/tem/${id}/destroy`, { note });
};
export const remove = (id, note) => {
  return service.post(`/v1/tem/${id}/remove`, { note });
};

export const addTem = (quantity, type, note, tem) => {
  return service.post(`/v1/tem/add`, { quantity, type, note, tem });
};
export const getTemScanner = code => {
  return service.get(`/v1/tem/scanner-code`, { code });
};
